import React, { useState } from 'react';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import { isInclusivelyBeforeDay } from 'react-dates';
import moment from 'moment/moment';

const DatePicker = ({ form: { setFieldValue, values } }) => {
  const [focusedInput, setFocusedInput] = useState(null);

  return (
    <DateRangePicker
      startDate={values.startDate}
      startDateId='tata-start-date'
      endDate={values.endDate}
      endDateId='tata-end-date'
      displayFormat=' DD MMM YYYY'
      onDatesChange={({ startDate, endDate }) => {
        setFieldValue('startDate', startDate);
        setFieldValue('endDate', endDate);
      }}
      focusedInput={focusedInput}
      isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
      onFocusChange={(focusInput) => setFocusedInput(focusInput)}
      minimumNights={0}
    />
  );
};

export default DatePicker;
